export const bloghome = 
[{
     
    alt:"Witness the power and style of a tuned white Mercedes C63S from Das Tuning as it cruises on the road, a testament to our exceptional car tuning services."
}]